import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface CloseButtonProps {
  onClick: () => void;
  colorClass?: string; // Optional custom color class
}

const CloseButton = ({ onClick, colorClass = "text-gray-400 hover:text-gray-500" }: CloseButtonProps) => {
  return (
    <button
      type="button"
      className={`rounded-md ${colorClass} focus:outline-none`}
      onClick={onClick}
    >
      <span className="sr-only">Close</span>
      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
    </button>
  );
};

export default CloseButton;
